export const isValidNumber = (value) => Number.isSafeInteger(Number.parseInt(value));
export const parseIntegerData = (value) => Number.parseInt(value);
